import React, { useEffect, useState } from "react";
import { TimeoutWarningModal } from "./timeout-warning-modal";
import { addEventListeners, removeEventListeners } from "./eventListenerUtil";
import { useNavigate } from "react-router";
import { sessionTimeoutSelector } from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import AuthService from "../../services/auth.service";

export const TimeoutLogic = () => {
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  const sesssiontimeOut = useSelector(sessionTimeoutSelector);
  const navigate = useNavigate();

  useEffect(() => {
    
    if (sesssiontimeOut > 0) {
      const createTimeout1 = () =>
        setTimeout(() => {
          setWarningModalOpen(true);
        }, sesssiontimeOut);

      const listener = () => {
        if (!isWarningModalOpen) {
          clearTimeout(timeout);
          timeout = createTimeout1();
          return false;
        }
      };

      // Initialization
      let timeout = createTimeout1();
      addEventListeners(listener);

      // Cleanup
      return () => {
        removeEventListeners(listener);
        clearTimeout(timeout);
      };
    }
  }, [isWarningModalOpen]);

  return (
    <div>
      {isWarningModalOpen && (
        <TimeoutWarningModal
          isOpen={isWarningModalOpen}
          onRequestClose={async () => {
            setWarningModalOpen(false);
            await AuthService.kikRefreshToken();
          }}
        />
      )}
    </div>
  );
};
